import { render } from "./A01PointNotificationPanelInvested.vue?vue&type=template&id=5882a210&scoped=true&ts=true"
import script from "./A01PointNotificationPanelInvested.vue?vue&type=script&lang=ts"
export * from "./A01PointNotificationPanelInvested.vue?vue&type=script&lang=ts"

import "./A01PointNotificationPanelInvested.vue?vue&type=style&index=0&id=5882a210&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5882a210"]])

export default __exports__